import { render, staticRenderFns } from "./PreviewStatus.vue?vue&type=template&id=08146501&"
import script from "./PreviewStatus.vue?vue&type=script&lang=js&"
export * from "./PreviewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports